<template>
  <transition name="fade">
    <div class="modal" v-if="show">
      <div :class="{modalContent: true, dragover: dragover, uploading: uploading}"
        v-on:drop.prevent="addFile" v-on:dragover.prevent
        v-on:dragstart="dragStart" v-on:dragenter="dragStart" v-on:dragend="dragEnd"
        v-on:dragexit="dragEnd" v-on:dragleave="dragEnd">
        <div class="close" v-on:click="close(false)"/>
        <div class="uploadingCnt" v-if="uploading">
          <h4>Uploading {{fileUploaded}} of {{imageFiles.length}} files...</h4>
          <p>Upload progress: {{uploadPorgress}}%</p>
          <div class="uploadPorgress">
            <div class="progress" v-bind:style="{width: `${uploadPorgress}%`}"></div>
          </div>
        </div>
        <div class="loading" v-if="loading"></div>
        <div class="modalContentIn" v-if="!uploading">
          <h4>Drop files here to upload</h4>
          <p>Allowed file types: .jpg .png .mp3 .ogg .mp4</p>
          <br>
          or
          <br>
          <br>
          <button v-on:click="$refs.file.click()" class="selectFile">Select File</button>
          <button v-on:click="addYoutube" class="addYoutube">Add Youtube Video</button>
          <input type="file" ref="file"
            accept="image/png,image/x-png,image/jpeg,image/jpg,audio/mpeg,
              audio/mp3,audio/ogg,video/mp4,video/webm"
            v-on:change="handleFile" multiple="true"
            style="display: none">
        </div>
      </div>
      <MediaInputer ref="mediaInputer"/>
    </div>
  </transition>
</template>

<script>
import MediaInputer from './MediaInputer.vue';

export default {
  props: ['title', 'desc', 'action'],
  components: { MediaInputer },
  data() {
    return {
      show: false,
      next: null,
      fileUploaded: 0,
      imageFiles: [],
      dragover: false,
      uploading: false,
      uploadPorgress: 0,
      loading: false,
    };
  },
  methods: {
    open(d, next) {
      this.show = true;
      this.next = next;
    },
    close(b, data) {
      this.show = false;
      if (this.next && typeof this.next === 'function') this.next(b, data);
    },
    addYoutube() {
      this.$refs.mediaInputer.open({
        title: 'Youtube Video Url',
        placeholder: 'https://youtube.com/...',
        action: 'Add Video',
      }, (b, v) => {
        if (!b) return;
        this.loading = true;
        this.$http.post(this.$config.uri('media/youtube'), { url: v }).then((r) => {
          this.close(true, r.data.media);
          this.loading = false;
        });
      });
    },
    doUpload() {
      this.uploading = true;
      this.imageFiles.forEach((file) => {
        const formData = new FormData();
        formData.append('image', file);
        this.$http.post(this.$config.uri('media/save'), formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
          onUploadProgress: (progressEvent) => {
            this.uploadPorgress = Math.floor(progressEvent.loaded / progressEvent.total * 100);
          },
        }).then((imgResponse) => {
          this.fileUploaded += 1;
          if (this.fileUploaded === this.imageFiles.length) {
            // Upload finished...
            this.close(true, imgResponse.data.media);
          }
        });
      });
    },
    handleFile() {
      if (this.uploading) return;
      this.imageFiles = this.$refs.file.files;
      this.doUpload();
    },
    addFile(e) {
      this.dragover = false;
      if (this.uploading) return;
      const droppedFiles = e.dataTransfer.files;
      if (!droppedFiles) return;
      ([...droppedFiles]).forEach((f) => {
        this.imageFiles.push(f);
      });
      this.doUpload();
    },
    dragStart() {
      this.dragover = true;
    },
    dragEnd() {
      this.dragover = false;
    },
  },
};
</script>

<style scoped lang="scss">
  .modal{
    position: fixed;
    top: 0; left: 0; right: 0; bottom: 0;
    z-index: 9;
    z-index: 99999;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #fff;
    // background-color: rgba(255,255,255,.8);
    // backdrop-filter: saturate(180%) blur(20px);
    .modalContent{
      position: absolute;
      left: 20px; top: 20px; right: 20px; bottom: 20px;
      border: #ccc 4px dashed;
      border-radius: 0;
      text-align: center;
      max-width: none;
      margin: 0;
      overflow: visible;
      .loading{
        background-color: #fff;
        background-image: url(../assets/loading-2.svg);
        background-size: 46px auto;
        background-position: center;
        background-repeat: no-repeat;
        position: absolute;
        top: -10px; right: -10px; left: -10px; bottom: -10px;
        z-index: 9;
      }
      &.dragover{
        border-color: #0057d8;
      }
      &.uploading{
        border-color: transparent;
        .uploadingCnt{
          position: absolute;
          left: 50%; top: 50%;
          color: #444;
          transform: translate(-50%, -50%);
          .uploadPorgress{
            height: 10px;
            background-color: #ddd;
            border-radius: 50px;
            margin-top: 20px;
            .progress{
              background-color: #0f5cd2;
              height: 100%;
              border-radius: 50px;
            }
            span{
              display: none;
            }
          }
          h4{
            margin: 0 0 6px;
            font-size: 24px;
          }
          p{
            color: #767676;
            font-size: 13px;
          }
        }
      }
      .close{
        position: absolute;
        right: -15px; top: -15px;
        background-color: #fff;
        border-radius: 50%;
        width: 40px; height: 40px;
        background-image: url(../assets/close.png);
        background-size: 14px auto;
        background-repeat: no-repeat;
        background-position: center;
        cursor: pointer;
        &:hover{
          background-color: #eee;
        }
      }
      .modalContentIn{
        text-align: center;
        position: absolute;
        left: 50%; top: 50%;
        transform: translate(-50%, -50%);
        color: #767676;
        h4{
          margin: 0;
          font-size: 24px;
          font-weight: normal;
          margin-bottom: 5px;
          color: #444;
        }
        p{
          margin: 0;
          color: #767676;
        }
        button{
          border-radius: 3px;
          color: #fff;
          border: none;
          box-shadow: none;
          font-size: 18px;
          background-color: #0057d8;
          padding: 10px 16px;
          padding-left: 42px;
          outline: 0;
          cursor: pointer;
          margin: 0 5px;
          position: relative;
          box-sizing: border-box;
          &:before{
            content: "";
            position: absolute;
            left: 16px; top: 0; bottom: 1px;
            width: 17px;
            background-size: contain;
            background-position: center;
            background-repeat: no-repeat;
          }
          &.selectFile{
            &:before{
              background-image: url(../assets/folder-white.png);
            }
          }
          &:hover{
            background-color: #0067ff;
          }
          &.addYoutube{
            background-color: #fff;
            border: #999 1px solid;
            color: #444;
            &:before{
              background-image: url(../assets/youtube.png);
            }
            &:hover{
              background-color: #eee;
            }
          }
        }
      }
    }
  }
</style>
